<div class="d-flex flex-column px-3 pt-3">
  <div class="cursor-pointer" (click)="dialogRef.close('updateFavorite')" id="update-favorite">
      <span class="popup-text">{{isFavorite}} {{'edp.emarket.popup.favorito' | translate}}</span>
  </div>
  <div class="popup-separator my-2"></div>
  <div class="cursor-pointer" (click)="dialogRef.close('createAlert')" id="create-alert">
      <span class="popup-text">{{hasAlert}} {{'edp.emarket.popup.alerta' | translate}}</span>
  </div>
</div>
